import { EAnswerInputType } from "@frameworks/salesjourney/components/Generic/FormComponentGenerator";
import { EFormCustomComponent } from "./FieldWrapper";
export var reportsconstantData = { searchResultId: "-1" };
// ===========================AS off now dummy data==========================================
export var ReportsCategory = [
    {
        id: 1,
        category: "Adhoc Report",
        reports: [
            { id: 1, name: "DSA Log Details" },
            { id: 2, name: "Nexsus Call Report" },
            { id: 3, name: "Nexsus Device Status Report" },
            { id: 4, name: "Nexsus Reconcilation Report" },
            { id: 5, name: "RM CXO Mapping" },
        ],
    },
    {
        id: 2,
        category: "Business Report",
        reports: [
            { id: 6, name: "RM CXO Mapping" },
            { id: 7, name: "Nexsus Call Report" },
            { id: 8, name: "No Pre Order Confirmation Report" },
            { id: 9, name: "Nexsus Reconcilation Report" },
            { id: 10, name: "Risk" },
        ],
    },
    {
        id: 3,
        category: "Other Report",
        reports: [
            { id: 11, name: "DSA Log Details" },
            { id: 12, name: "Nexsus Call Report" },
            { id: 13, name: "Nexsus Device Status Report" },
            { id: 14, name: "Nexsus Reconcilation Report" },
            { id: 15, name: "RM CXO Mapping" },
        ],
    },
    {
        id: 4,
        category: "Adhoc Report",
        reports: [
            { id: 16, name: "DSA Log Details" },
            { id: 17, name: "Nexsus Call Report" },
            { id: 18, name: "Nexsus Device Status Report" },
            { id: 19, name: "Nexsus Reconcilation Report" },
            { id: 20, name: "RM CXO Mapping" },
        ],
    },
];
export var allReports = ReportsCategory.reduce(function (allReports, currentCategoryReports) {
    return allReports.concat(currentCategoryReports.reports);
}, []);
export var mastersData = {
    categoryList: [
        { label: "Category 1", value: 1 },
        { label: "Category 2", value: 2 },
        { label: "Category 3", value: 3 },
        { label: "Category 4", value: 4 },
        { label: "Category 5", value: 5 },
        { label: "Category 6", value: 6 },
        { label: "Category 7", value: 7 },
        { label: "Category 8", value: 8 },
        { label: "Category 9", value: 9 },
        { label: "Category 10", value: 10 },
    ],
    subCategoryList: [
        { label: "Subcategory A", value: "A" },
        { label: "Subcategory B", value: "B" },
        { label: "Subcategory C", value: "C" },
    ],
    statusList: [
        { label: "Active", value: "active" },
        { label: "Inactive", value: "inactive" },
    ],
};
export var assetReportMastersData = {
    accountOpenDateRangeList: [
        { label: "All", value: 1 },
        { label: "For this month", value: 2 },
        { label: "Custom", value: 3 },
    ],
    columnsCategoryList: [
        { label: "All", value: 1 },
        { label: "Select columns", value: 2 },
    ],
    columnList: [
        { label: "Column 1", value: 1 },
        { label: "Column 2", value: 2 },
        { label: "Column 3", value: 3 },
    ],
    ownerSubLobCategoryList: [
        { label: "All", value: 1 },
        { label: "Select Owner Sub Lob", value: 2 },
    ],
    ownerSubLobList: [
        { label: "Lob 1", value: "lob-1" },
        { label: "Lob 2", value: "lob-2" },
        { label: "Lob 3", value: "lob-3" },
    ],
};
export var getFieldType = {
    number: EAnswerInputType.BLANK_INPUT,
    text: EAnswerInputType.BLANK_INPUT,
    ddl: EAnswerInputType.SELECT,
    checkbox: EAnswerInputType.CHECKBOX,
    radio: EAnswerInputType.RADIO,
    datetime: EAnswerInputType.DATE,
    multiddl: EAnswerInputType.DROPDOWN_SEARCH,
    label: EFormCustomComponent.LABEL,
    daterange: EFormCustomComponent.DATE_RANGE,
};
export var FIeldInfo = [
    {
        fieldName: "Date",
        fieldType: EAnswerInputType.DATE,
        fieldParams: "Ondate",
        isMandatory: true,
    },
    {
        fieldName: "Number",
        fieldType: EAnswerInputType.BLANK_INPUT,
        fieldParams: "number",
        isMandatory: true,
    },
    {
        fieldName: "Dropdown",
        fieldType: EAnswerInputType.SELECT,
        fieldParams: "dropdown",
        isMandatory: true,
    },
    {
        fieldName: "Checkbox",
        fieldType: EAnswerInputType.CHECKBOX,
        fieldParams: "checkbox",
        isMandatory: true,
    },
    {
        fieldName: "Radio",
        fieldType: EAnswerInputType.RADIO,
        fieldParams: "radio",
        isMandatory: true,
    },
];
export var ZeroisingPopUpdropdownList = [
    { label: "Select", value: "" },
    {
        label: "EQUITY",
        value: "EQ",
    },
    {
        label: "COMMODITY",
        value: "CO",
    },
];
export var zeroisingPopUpRadioList = [
    {
        display: "Tentative",
        value: "Tentative",
    },
    {
        display: "Final",
        value: "Final",
    },
];
// ==================================================================
